import { NgModule } from 'ng-metadata/core';
import { ngSlickConfig } from './slick.config';
import { ngAnimateConfig } from './animate.config';
import { ngHeadroomConfig } from './headroom.config';
import { ngMaterialConfig } from './material.config';
import { ngStorageConfig } from './local-storage.config';
import { ngDatetimeFormat } from './datetimeFormat.config';


@NgModule({
  providers: [
    ngSlickConfig,
    ngAnimateConfig,
    ngStorageConfig,
    ngHeadroomConfig,
    ngMaterialConfig,
    ngDatetimeFormat,
  ],
})
export class ConfigModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/config/config.module.ts